var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.2947C8.55229 11.2947 9 10.847 9 10.2947C9 9.74239 8.55229 9.29468 8 9.29468C7.44772 9.29468 7 9.74239 7 10.2947C7 10.847 7.44772 11.2947 8 11.2947Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.2947C13 10.847 12.5523 11.2947 12 11.2947C11.4477 11.2947 11 10.847 11 10.2947C11 9.74239 11.4477 9.29468 12 9.29468C12.5523 9.29468 13 9.74239 13 10.2947Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.2947C16.5523 11.2947 17 10.847 17 10.2947C17 9.74239 16.5523 9.29468 16 9.29468C15.4477 9.29468 15 9.74239 15 10.2947C15 10.847 15.4477 11.2947 16 11.2947Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99993 2.99463C3.34382 2.99463 1.99996 4.3359 2 5.9935L2.00026 14.5989C2.00031 16.2584 3.34614 17.5946 5.00026 17.5946H6.99983V20.9646C6.99983 21.3629 7.23613 21.7231 7.60139 21.8818C7.96665 22.0405 8.39125 21.9673 8.68232 21.6955L13.0741 17.5946H18.9997C20.6564 17.5946 21.9999 16.2519 21.9998 14.5947C21.9996 12.3547 21.9997 9.91948 21.9998 7.60502L21.9998 5.99424C21.9998 4.33709 20.6564 2.99463 18.9998 2.99463H4.99993ZM4 5.99345C3.99999 5.44193 4.44693 4.99463 4.99993 4.99463H18.9998C19.5524 4.99463 19.9998 5.4422 19.9998 5.99419L19.9998 7.60444C19.9997 9.91904 19.9996 12.3545 19.9998 14.5948C19.9998 15.147 19.5523 15.5946 18.9997 15.5946H12.6798C12.4265 15.5946 12.1825 15.6908 11.9973 15.8637L8.99983 18.6627V16.5946C8.99983 16.0423 8.55212 15.5946 7.99983 15.5946H5.00026C4.44528 15.5946 4.00027 15.1484 4.00026 14.5988L4 5.99345Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsOutline);
export default __webpack_public_path__ + "static/media/sms_outline.96d8db4d44219791348e144d7eaf5c31.svg";
export { ForwardRef as ReactComponent };